import { render, staticRenderFns } from "./DailyOmsetByCategory.vue?vue&type=template&id=0bcf9f60&scoped=true"
import script from "./DailyOmsetByCategory.vue?vue&type=script&lang=js"
export * from "./DailyOmsetByCategory.vue?vue&type=script&lang=js"
import style0 from "./DailyOmsetByCategory.vue?vue&type=style&index=0&id=0bcf9f60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcf9f60",
  null
  
)

export default component.exports